export default "__VITE_ASSET__BMJB5fCa__"